import { RouteStrategy } from '../../../components/MainHeader/types/onClickAccountOption'
import handleLogout from '../../../components/MainHeader/utils/logout'

const routerStrategy: RouteStrategy = {
  home: () => '/',
  help: () => '/account/help',
  'log-in': () => '/login',
  'log-out': () => {
    handleLogout()
    return '/'
  },
  register: () => '/register',
  info: () => '/account/info',
  orders: () => '/account/orders',
  addresses: () => '/account/addresses',
  favorites: () => '/account/favorites',
  loyalty: () => '/account/loyalty',
  default: () => '/',
}

const getAccountOption = (route: string) => {
  const strategy = routerStrategy[route] || routerStrategy.default
  return strategy(route)
}

export default getAccountOption
